import { getEnv } from '@unni/platform'

export const DATADOG_SERVICE_NAME = 'cheetah'
export const DATADOG_ENV: 'prod' | 'test' = getEnv('NEXT_PUBLIC_ENV') === 'prod' ? 'prod' : 'test'
